import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import {  GelAllContactRequestModel } from '../../models/filter.model';
import { SharedContactV1Service } from './shared-contact-v1-Service';
import { Subject, debounceTime, distinctUntilChanged, takeUntil } from 'rxjs';
import { ChannelN } from '../../models/channel.model';
import { AppMainService } from 'src/app/app-main.service';
import { ConfirmationService , MessageService } from 'primeng/api';
import { AppMainComponent } from 'src/app/app.main.component';
import { ColumnSettingsN, Fields, } from '../../models/column-settings.model';
import { SharedColumnSettingsService } from '../../services/column-settings.service';
import { AccountModuleId, ContactModuleId } from '../../constants/modules.constant';
import { AccountHelper } from 'src/app/accounts-v2/services/accounts.helper';
import { FormControl } from '@angular/forms';
import { Status } from 'src/app/models/statusEnums';
import { PermissionService } from 'src/app/service/permission.service';
import { ObjectNames } from 'src/app/shared/constants';
import { ContactService } from 'src/app/contacts/contactService';
import { SharedChannelService } from '../../services/channel.service';
import { DatePipe , Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalDatePipe } from 'src/app/shared/pipes/local-date.pipe';
import { PHONE_NUMBER_CODE_MAP, PHONE_TYPE_IDS } from '../../constants/typeId';
import { FilterInColumn } from 'src/app/accounts-v2/models/account-request.model';

@Component({
  selector: 'app-shared-contacts-v1',
  templateUrl: './shared-contacts-v1.component.html',
  styleUrl: './shared-contacts-v1.component.scss',
  providers: [LocalDatePipe]
})
export class SharedContactsV1Component implements OnInit, OnChanges {
  @Input() associationTypeName: string = '';
  @Input() isShowSideBtn: boolean = false;
  @Output() changeSideHeader = new EventEmitter<any>();
  @ViewChild('cm') contextMenu: any;
  contacts: any[] = [];
  pageSize: number = 15;
  pageNumber: number = 1;
  totalRecords: number = 0;
  private ngUnsubscribe = new Subject<void>();
  selectedRecent = { label: 'All Contacts', code: 'allcontacts' };
  isActive: boolean = true;
  selectedChannelN: number = 1;
  contactStagesAll = [];
  selectedChannelNData: any = {id: 1, name: 'Account Default Channel', isDefault: true};
  globalChannelId: number = 0;
  globalSearchChannelId: number = 0;
  noCaseFindOrLoadingText : string = "loading...";
  recentItems = [
    { label: 'All Contacts', code: 'allcontacts' },
    { label: 'My Contacts', code: 'my_contacts' },
    { label: 'New last week', code: 'new_last_week' },
    { label: 'New this week', code: 'new_this_week' },
    { label: 'New this month', code: 'new_this_month' },
    // { label: 'Recently Viewed Contacts', code: 'recently_viewed' },
  ];
  first = 0;
  selectedAssociationType: string = '';
  contactsData = [];
  showFloatHeader: boolean = false;
  noContactFindOrLoadingText = 'Loading....';
  channelsN: ChannelN[] = [];
  displaySettings = false;
  totalAmt = 0;
  totalAmt2 = 0;
  tempContactStepBar;
  tempCols;
  contactSettings;
  tempDetailViewCols;
  savedContactDetailViewCols = [];
  maxNo = false;
  maxNo2 = false;
  tableShowMore: number[] = [15, 30, 50, 100];
  menuItems = [] ;
  sortFlag: boolean = true;
  sortCol: string = '';
  displayColumnSettings: boolean = false;
  disabledLabelNames: string[] = [];
  columnSettingsN: Partial<ColumnSettingsN> = {};
  savedDefaultView: string;
  savedListCols: Fields[] = [];
  savedListColsVM: Fields[] = [];
  splitView: Fields[] = [];
  globalSearchData : any[]= [];
  savedDetailViewCols: Fields[] = [];
  listColsAll: Fields[] = [];
  enabledListCols: Fields[] = [];
  selectedGroupByValue: any = null;
  accountListCols = [];
  selectedStep: number = 1;
  selectedStageId: number;
  configMenuItems = [];
  configMenuItemsCM = [];
  displayContactAddEdit: boolean = false;
  searchControl = new FormControl();
  moduleSearchValue: string = "";
  searchValue = "";
  selectedColumn: { columnName: string; isCustom: boolean }[];
  contactModalHeader = '';
  contactTemp: any = {};
  selectedContact: any;
  selectedContactForContextMenu: any;

  //region permission var
  readPermission = false;
  writePermission = false;
  editPermission = false;
  deletePermission = false;
  exportPermission = false;

  //endregion permission var
  isMenuShow: boolean = true;
  filteredContacts: object;
  selectedId;
  selectedContactFromTable = 0;
  contactColsAllTemp = [];
  contactPopupOpenMode: 'add' | 'view' | 'edit' = 'view';
  selectedView: string;
  selectedViewContact: any;
  selectedChannelN1: ChannelN;

  //active/incative
  displayActiveInactiveModal: boolean = false;
  selectedIdForActiveInactive: number;
  statusId: number;
  moduleName: string = 'Contacts';
  activeInactiveFormType: string;

  objectTypeId: number;
  isLeftTableHide: boolean = false;
  mainContactModule: boolean = true;
  contactAssociation = [] ;
  sortColumn:any;
  filterInColumns = [];
  public readonly phoneNumberCodeMap = PHONE_NUMBER_CODE_MAP;
  gridState: any = {};
  fromGlobalSearch :boolean = false ; 
  displayGlobalSearchTab  :boolean = false ;
  socialColumns = [
    'contactsocialwebsite',
    'contactsocialfacebook',
    'contactsociallinkedin',
    'contactsocialinstagram',
    'contactsocialtwitter'
  ];
  descriptionColumns = ['description'];
  dateColumns = ['startDate', 'createdDate', 'updatedDate', 'birth']; 
  
  constructor(
    private sharedContactV1Service: SharedContactV1Service,private _location: Location,
    private appMainService: AppMainService,
    private messageService: MessageService,
    public app: AppMainComponent, private contactService: ContactService,public localDatePipe: LocalDatePipe,
    private sharedColumnSettingsService: SharedColumnSettingsService,public datepipe: DatePipe,
    private accountHelper: AccountHelper, private sharedChannelService: SharedChannelService,
    private permissionService: PermissionService, private activatedRoute: ActivatedRoute,private router: Router,
    private confirmationService: ConfirmationService 
  ) {
    
    this.activatedRoute.queryParamMap.subscribe((queryParams) => {
      const id = queryParams.get('id');
      const assocTypeId = queryParams.get('assocTypeId');
      this.globalSearchChannelId = +queryParams.get('channelId');
      if (id) {
        this.getColumnSettings(false, true);
        this.fromGlobalSearch = true;
        this.displayGlobalSearchTab  = true;
        this.contactService.getAllContactAssociation().then(asso => {
          this.contactAssociation = asso;
          this.associationTypeName = this.contactAssociation?.find(ele => ele.id == assocTypeId)?.name.toLowerCase();
          this.onRowSelect({ data: { id: id, contactAssociationTypeId: assocTypeId } })
        });
      }
      // else{
      //   this.router.navigate(['notfound']);
      // }
    })
  }

  ngOnInit(): void {
    this.objectTypeId = this.app.objectTypeId ?? 40;
    this.getAccountChannel();
    this.updatePermissionsAndMenu();
    this.searchContacts();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.associationTypeName && changes.associationTypeName.currentValue) {
      this.associationTypeName = changes.associationTypeName.currentValue;
      this.getColumnSettings(false,false);
    }
    this.getAllContactassociation();
  }

  //#region Global Search
  searchContacts() {

    this.searchControl.valueChanges.pipe(
      debounceTime(1000),
      distinctUntilChanged(),
      takeUntil(this.ngUnsubscribe)
    ).subscribe((value: string) => {
      this.searchValue = value.trim() || '';
      this.loadContacts();
    });
  }
  //#endregion Global Search

  getAccountChannel() {
    const globalChannelId = this.permissionService.getGlobalChannelId();
    if (typeof globalChannelId === 'number') {
      this.selectedChannelN1 = { id: globalChannelId } as any;
    }

    this.sharedChannelService.getChannels(AccountModuleId)
    .subscribe({
      next: (response) => {
        const channels = response || [];
        this.channelsN = this.permissionService.filterChannelsByPermissions(channels, ObjectNames.CONTACT);
        this.channelsN?.map(channel => {
          if (!channel?.name.toLowerCase().includes("account"))
            channel.name = `Account ${channel?.name}`;

          if (!channel?.name.toLowerCase().includes("channel"))
            channel.name = `${channel?.name} Channel`;
        });
        setTimeout(() => {
          const globalChannelId = this.permissionService.getGlobalChannelId();
          if (typeof globalChannelId === 'number') {
            this.selectedChannelN1 = this.channelsN.find(x => x?.id === globalChannelId);
          } else {
            this.selectedChannelN1 = this.channelsN.find(x => x?.isDefault);
          }
          this.globalChannelId = this.selectedChannelN1?.id
        })
      },
      error: (error) => {
        this.appMainService.isHideSpinner('getChannel');
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error?.error?.message ? error?.error?.message : 'Channels are not loaded, please try again...'
        });

      },
      complete: () => {

      }
    });
  }

  onAccountChannelChanged(event) {
    this.globalChannelId = event?.value?.id ;
    this.first = 0;
    this.loadContactList();
    
  }

  getStageCount() {
    this.contactService.getContactCount(this.selectedRecent.code, this.isActive, this.globalChannelId).pipe(takeUntil(this.ngUnsubscribe)).subscribe({
      next: (data: any) => {
        this.contactStagesAll = data?.filter(
          (contact) => contact.name !== "Vendor Contacts" && contact.name !== "Account Contacts"
        );
      }
    })
  }
  stepClicked(i, stage) {
    if (this.selectedStep === i + 1) {
      return;
    }
    this.selectedStep = i + 1;
    this.first = 0;
    const name = stage.name?.toLowerCase().split(" ")[0];
    this.selectedAssociationType = name == "all" ? "" : name;
    if (stage.name == 'Vendor Contacts') {
      this.associationTypeName = "vendor"
    } else if (stage.name == 'Lead Contacts') {
      this.associationTypeName = "lead"
    } else if (stage.name == 'Account Contacts') {
      this.associationTypeName = "account"
    } else if (stage.name == 'Organization Contacts') {
      this.associationTypeName = "organization"
    } else {
      this.associationTypeName = ""
    }
    this.loadContacts();
  }

  loadContacts(currentPageNumber: number = 1, currentPageSize: number = this.pageSize, isShowLoader: boolean = true, sortFlag: boolean = true, sortCol: string = '') {
    this.pageSize = currentPageSize;
    //#region Select Column
    const selectableColumns: any[] = [];
    this.selectedColumn = [];

    if (this.savedListColsVM.length > 0) {
      this.savedListColsVM.forEach((obj) => {
        if (obj.enabled) {
          selectableColumns.push(
            {
              columnName: obj.columnName,
              isCustom: obj.isCustom
            }
          )
        }
      });
      this.selectedColumn = [...selectableColumns];
    }
    this.appMainService.isShowSpinner('getAllContactLoader');
    //#endregion Select Column
    const requestModel: GelAllContactRequestModel = {
      associationTypeName: this.associationTypeName,
      isActive: this.isActive,
      globalSearchValue: this.searchValue?.trim() || '',
      selectableColumns: this.selectedColumn,
      filterInColumns : this.filterInColumns || [],
      filter: this.selectedRecent?.code || 'allcontacts',
      pageSize: currentPageSize,
      pageNumber: currentPageNumber,
      sortByColumn: sortCol || null,
      isSortByDescending: sortFlag,
      filterableColumns: this.gridState?.filters ?? [],
      globalChannelId: this.globalChannelId || this.selectedChannelN1?.id,
    };
    this.sharedContactV1Service.getContactList(requestModel)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (response) => {
          this.contacts = JSON.parse(JSON.stringify(response.list));
          this.totalRecords = response.totalNumberOfRows;
          this.noCaseFindOrLoadingText = !this.totalRecords ? "No Contacts found." : "";
            this.appMainService.isHideSpinner('getAllContactLoader');
        },
        (error) => {
          this.noCaseFindOrLoadingText = 'Error loading contacts';
          this.appMainService.isHideSpinner('getAllContactLoader');
        }
      );
  }
  refreshList(e) {
    if (this.searchControl.value) {
      this.searchControl.setValue(''); 
      this.searchValue = '';
    }
    this.sortFlag = false;
    this.sortCol = "";
    this.pageNumber = 1;
    this.pageSize = 15;
    this.loadContactList();
    if(this.selectedView == 'split'){
    this.onRowSelect(this.selectedViewContact)
    }
  }
  //#region Column Setting

  settings() {
    this.totalAmt = 0;
    this.totalAmt2 = 0;
    this.tempCols = this.contactSettings?.listCols || [];
    this.tempDetailViewCols = this.savedContactDetailViewCols || [];
    for (let col of this.tempCols) {
      if (col.checked == true) { this.totalAmt++; }
    }
    this.maxNo = this.totalAmt >= 7;
    for (let col of this.tempDetailViewCols) {
      if (col.checked == true) { this.totalAmt2++; }
    }
    this.maxNo2 = this.totalAmt2 >= 12;
    this.displaySettings = true;
    this.openContactSettings();
  }

  openContactSettings(): void {
    this.displaySettings = true;
    this.displayColumnSettings = true;
    this.getColumnSettings(true).catch(error => {
      this.displaySettings = true;
      this.displayColumnSettings = true;
    });
  }

  savedColumnSettings(): void {
    this.displayColumnSettings = false;
    this.getColumnSettings(true);
  }

  cancelColumnSettings(): void {
    this.displayColumnSettings = false;
  }
  recentUpdate() {
    this.first = 0;
    this.loadContactList();
  }

  onStatusChanged() {
    this.first = 0;
    this.selectedView ='list' 
    this.loadContactList();
  }

  getColumnSettings(fromUpdateSettings = false,fromGlobalSearch?): Promise<void> {
    return new Promise((resolve, reject) => {
      this.appMainService.isShowSpinner('getColumnSettings');
      this.sharedColumnSettingsService.getColumnSettings(ContactModuleId, 1)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe({
          next: (response) => {
            this.columnSettingsN = response || {};
            this.appMainService.isHideSpinner('getColumnSettings');
            if(!this.displayColumnSettings){
            this.processColumnSettings(this.columnSettingsN, fromUpdateSettings,fromGlobalSearch);
            }
            resolve(); // Resolve the promise after successful data processing
          },
          error: (error) => {
            this.appMainService.isHideSpinner('getColumnSettings');
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: error?.error?.message ? error?.error?.Message : 'Column Settings are not loaded, please try again...'
            });
            reject(error); // Reject the promise in case of an error
          },
          complete: () => {
            if(!this.displayColumnSettings  && fromUpdateSettings){
            this.loadContacts();
            }
          },
        });
    });
  }

  applyFilters(event: { selectedFilter: FilterInColumn[], selectedColumnsForSaveFilterFieldsChannelWise: FilterInColumn[]}) {
    this.filterInColumns = event?.selectedFilter||null;
    this.loadContacts();
}

isSocialColumn(columnName: string): boolean {
  return this.socialColumns?.includes(columnName);
}

isDescriptionColumn(columnName: string): boolean {
  return this.descriptionColumns?.includes(columnName);
}

isDateColumn(columnName: string): boolean {
  return this.dateColumns?.includes(columnName);
}

  processColumnSettings(columnSettings: Partial<ColumnSettingsN>, fromUpdateSettings = false,fromGlobalSearch?): void {
  if(fromGlobalSearch){
    this.savedDefaultView = 'split';
  }else{
    this.savedDefaultView = columnSettings?.defaultViewType == 1 ? 'list' : 'split';
  }
    if (columnSettings?.listViewSections) {
      this.savedListColsVM = this.accountHelper.getSectionWiseFlatCols(columnSettings?.listViewSections)?.filter(ele=>ele.enabled);
      this.setSelectedColumns();
    }

    if (columnSettings?.detailsViewSections) {
      this.savedDetailViewCols = this.accountHelper.getSectionWiseFlatCols(columnSettings?.detailsViewSections);
      this.contactColsAllTemp = this.savedDetailViewCols.map(item => {
        return {
          ...item,
          ischecked: item.enabled,
          labelname: item.name,
          header : item.name,
          field : item.columnName,
          show : item.enabled,
          checked :   item.enabled      
        };
      });
      if(!fromGlobalSearch){
        this.loadContactList()
      }
    }

    this.setUpdatedContactListCols()

    this.listColsAll = JSON.parse(JSON.stringify(this.savedListCols));
    if (!fromUpdateSettings) {
      this.selectedView = this.savedDefaultView;
    }
  }
  
  getData(event) {
    this.pageNumber = event.first / event.rows + 1;
    this.pageSize = event.rows;
    this.first = event.first;
    this.loadContacts(this.pageNumber, this.pageSize, false, this.sortFlag, this.sortCol); 
  }

  setSelectedColumns(): void {
    this.selectedColumn = this.savedListColsVM
      .filter(col => col.enabled)
      .map(col => ({
        columnName: col.columnName,
        isCustom: col.isCustom
      }));
  }

  setUpdatedContactListCols() {
    let matchedCol = this.savedListCols.filter(col => col.columnName === this.accountListCols[0].columnName);

    if (matchedCol.length) {
      this.accountListCols = JSON.parse(JSON.stringify(matchedCol));
    }
  }

  setListColumns(): void {
    this.savedListCols = this.accountHelper.getSectionWiseFlatCols(this.columnSettingsN?.listViewSections);
  }

  //#endregion Column Setting

  //sort on column
  onSortColumn(event) {
    this.sortFlag = !(event.order === 1);
    this.sortCol = event.field;
  }

  //#endregion Pagination

  openContactForm(): void {
    this.contactModalHeader = 'Add New Contact';
    this.selectedContact = null; 
  this.contactPopupOpenMode = 'add'
    this.displayContactAddEdit = true;

  }
  displayContactAddEditChange(event: boolean): void {
    this.displayContactAddEdit = event;
    if(this.selectedView == 'split'){
    this.onRowSelect(this.selectedViewContact)
    }
    if (!event) {
      this.contactModalHeader = '';
    }
  }
  
  getAllContactassociation(){
    this.sharedContactV1Service.getAllContactAssociation().subscribe(resp=>{
      this.contactAssociation = resp;
    })
  }

  //#region Context Menu
  onContextMenu(event) {
    let index = 0;
    this.configMenuItems = [];
this.associationTypeName = this.contactAssociation?.find(ele=>ele?.id == this.selectedContact?.contactAssociationTypeId)?.name?.toLowerCase() ; 
  this.configMenuItemsCM = [];
    const status = this.selectedContact.statusId == Status.Active ? 'Inactive' : 'Active';

    if (this.readPermission) {
      this.configMenuItems.push({
        label: 'View',
        icon: 'pi pi-list',
        command: async () => {
          this.viewContact(this.selectedContact);
        }
      });
      this.configMenuItemsCM.push({
        label: 'View',
        icon: 'pi pi-list',
        command: async () => {
          this.viewContact(this.selectedContact);
        }
      })
    }

    if (this.editPermission && this.selectedContact.statusId == 1) {
      this.configMenuItems.push({
        label: 'Edit',
        icon: 'pi pi-pencil',
        command: async () => {
          this.editContact(this.selectedContact);
        }
      });
      this.configMenuItemsCM.push({
        label: 'Edit',
        icon: 'pi pi-pencil',
        command: async () => {
          this.editContact(this.selectedContact);
        }
      })
    }

    if (this.deletePermission && this.selectedContact.statusId == 1) {
      this.configMenuItems.push({
        label: 'Delete',
        icon: 'pi pi-trash',
        command: async () => {
          this.deleteContact(this.selectedContact);
        }
      });
      this.configMenuItemsCM.push({
        label: 'Delete',
        icon: 'pi pi-trash',
        command: async () => {
          this.deleteContact(this.selectedContact);
        }
      })
    }

    if (this.editPermission && this.selectedContact.statusId) {
      index = this.configMenuItems.findIndex(item => item.label == 'Active Contact' || item.label == 'Inactive Contact');
      if (index !== -1) {
        this.configMenuItems.splice(index, 1);
      }
      index = this.configMenuItemsCM.findIndex(item => item.label == 'Active Contact' || item.label == 'Inactive Contact');
      if (index !== -1) {
        this.configMenuItemsCM.splice(index, 1);
      }
      this.configMenuItems.push({
        label: status + ' Contact',
        icon: 'pi pi-pencil',
        command: ($event) => {
          this.prepareContactforActiveInactive();
        }
      });
      this.configMenuItemsCM.push({
        label: status + ' Contact',
        icon: 'pi pi-pencil',
        command: ($event) => {
          this.prepareContactforActiveInactive();
        }
      });
    }
  }

  onRowSelect($event: any) {
      this.selectedViewContact = $event
      this.isMenuShow = false;
      this.selectedView = 'split';
      if(this.selectedView == 'split'){
        this.splitView = this.savedListColsVM?.filter(ele=>ele.name == 'Association Name')
      }
      if (!this.selectedContact) {
        this.selectedContact = {
          id: $event.data.id ,contactAssociationTypeId  :$event.data.contactAssociationTypeId
        }
      }
      this.filteredContacts = null;
      this.app.objectType = '';
      this.sharedContactV1Service.getContactById($event.data.id, $event.data.contactAssociationTypeId).then(contact => {
        if(this.fromGlobalSearch){
        this.globalSearchData = [];
        this.globalSearchData.push({id : contact?.id , name : contact?.firstName });
        }
        const updatedContact = this.getFormattedContacts([contact]);
        this.filteredContacts = updatedContact;
        this.app.objectId = this.selectedContact.id;
        this.selectedId = this.selectedContact.id;
        this.app.objectType = ObjectNames.CONTACT;
        this.selectedContactFromTable = this.selectedContact.id;
        
      })
    }

  onRowUnselect(event: any) {
   this.selectedContact = null;
   this.selectedView = 'list';
   this.isMenuShow = true;
  }


  backListView() {
    this.isMenuShow = true;
    if (this.fromGlobalSearch) {
      this.fromGlobalSearch = false;
      if(this.associationTypeName == 'account' || this.associationTypeName == 'vendor'){
        this.globalChannelId  = this.globalSearchChannelId;
        this.selectedChannelN1 = this.channelsN.find(x => x?.id === (this.globalChannelId ? this.globalChannelId : 1));
        this.loadContacts(this.pageNumber, this.pageSize, false, this.sortFlag, this.sortCol);
        this._location.go(`${this.associationTypeName + 's'}`);
      }else{
      this.router.navigate([`${this.associationTypeName + 's'}`]);
      }
    } 
      this.selectedView = 'list';
      this.selectedContact = null;
  }

  navigateToAccount(){
    this.router.navigate(['accounts']);
  }

  onRefreshList(){
    this.backListView();
  }

  hideMenu(type: 'menu' | 'table') {
    this.showFloatHeader = false;
    switch (type) {
      case 'menu':
        this.isMenuShow = false;
        break;
      case 'table':
        this.isLeftTableHide = true;
        break;
    }
    if(type == "menu"){
      setTimeout(()=>{
        this.showFloatHeader = true;
      }, 100);
    }
  }
  showMenu(type: 'menu' | 'table') {
    this.showFloatHeader = false;
    if(this.fromGlobalSearch){
    this.globalChannelId  = this.globalSearchChannelId;
    this.selectedChannelN1 = this.channelsN.find(x => x?.id === (this.globalChannelId ? this.globalChannelId : 1));
    }
    switch (type) {
      case 'menu':
        this.isMenuShow = true;
        break;
      case 'table':
        this.isLeftTableHide = false;
        break;
    }
    if(type == "menu"){
      setTimeout(()=>{
        this.showFloatHeader = true;
      }, 100);
    }
  }
  
  getFormattedContacts(contacts) {
    const socialProfilesMap = new Map(contacts[0]?.contactSocialProfiles?.map(ele => [ele?.socialProfile?.socialProfileType?.name, ele?.socialProfile?.name]));
    const phonelistMap = new Map(contacts[0]?.contactPhones?.map(ele => [ele?.phone?.phoneTypeId,ele?.phone?.number ? ele?.phone?.number : '']));
    const phonelistMapCode = new Map(contacts[0]?.contactPhones?.map(ele => [ele?.phone?.phoneTypeId,ele?.phone?.number ? ele?.phone?.code : '']));
    const emailMap = new Map(contacts[0]?.contactEmails?.map(ele => [ele?.email?.emailType?.name,ele?.email?.emailAddress]));

    this.appMainService.isShowSpinner('getFormattedContacts');
    for (let l of contacts) {
  
      const getDefaultAddress = (contactAddresses) => {
        const defaultTypes = ['billing', 'shipping', 'home address'];
        for (let type of defaultTypes) {
          const address = contactAddresses?.find(
            ele => ele?.address?.name?.toLowerCase() === type && ele?.address?.isDefault
          );
          if (address) return address.address;
        }
        return {};
      };
      
      const defaultAddress = getDefaultAddress(l.contactAddresses);
      

      l.middleName = l.middleName != null ? l.middleName : '';
      l.lastName = l.lastName != null ? l.lastName : '';
      let eachContact = {
        id: l.id,
        firstName: l.firstName,
        lastName: l.lastName,
        fullName:   (l.firstName ? l.firstName : '') +(l.middleName ? ' ' + l.middleName : '') + (l.lastName ? ' ' + l.lastName : ''),
        middleName: l.middleName ? l.middleName :  ' ' ,
        emailAddress: l?.contactEmails[0]?.email?.emailAddress ? l?.contactEmails[0]?.email?.emailAddress :  ' ' ,
        businessName: l.associationName,
        associationId: l.associationId,
        isPrimaryContact: l.isPrimaryContact ? 'Yes' : l.isPrimaryContact === false ? 'No' : '',
        title: l.salutation?.name,
        source: l.source ? l.source.name : null,
        assignedToUserId: l.assignedToUserId,
        streetAddress2: defaultAddress?.streetAddress2 || "",
        streetAddress1: defaultAddress?.streetAddress1 || "",
        zipCode: defaultAddress?.zipCode || "",
        state: defaultAddress?.state?.name || "",
        city: defaultAddress?.city?.name || null,
        country: defaultAddress?.country?.name || null,
        addressTypeName: defaultAddress?.addressType?.name || null,
        addressClassName: defaultAddress?.addressClass?.name || null,
        zipcode : defaultAddress?.zipCode || null,
        birth: l.dateOfBirth ? this.localDatePipe.transform(l.dateOfBirth, 'date'): null,
        gender: l.gender ? l.gender.name : null,
        language: l.contactSpokenLanguages && l.contactSpokenLanguages[0] && l.contactSpokenLanguages[0].language ? l.contactSpokenLanguages?.map((item) => item.language.name).join(", ") : null,
        contactType: l.contactType ? l.contactType.name : null,
        sequenceNumber: l.sequenceNumber ? l.sequenceNumber : null,
        contactAssociation: l?.contactAssociationType ? l?.contactAssociationType?.name : null,
        contactAssociationId:  l.contactAssociationTypeId,
        department: l.department,
        relation: l.relationshipStatus ? l.relationshipStatus.name : null,
        marital: l.maritalStatus ? l.maritalStatus.name : null,
        income: l.annualIncome ? l.annualIncome.name : null,
        degree: l.degree ? l.degree.name : null,
        studyField: l.fieldOfStudy ? l.fieldOfStudy.name : null,
        seniority: l.seniority,
        assistantPhone: l.assistantPhone,
        assistantPhoneCode :l?.assPhoneCode || '',
        report: l.reportsTo?.firstName ?? null,
        assistant: l.assistant ? `${l.assistant.firstName}  ${l.assistant.lastName}` : null,
        createdByName: l.createdByUserName ?? '',
        updatedByName: l.updatedByUserName ?? '',
        createdDate: this.localDatePipe.transform(l.createdDate, 'date'),
        updatedDate: this.localDatePipe.transform(l.updatedDate, 'date'),
        startDate: l.startDate  ? this.localDatePipe.transform(l.startDate, 'date'): null,
        description: l?.description ? l.description + "..." : '',
        profileImage : l?.contactProfileImages ? l?.contactProfileImages[0]?.attachment?.name : '' ,
        jobFunction : l?.role?.name ?? '',
        contact_roles: l?.contactRoles?.map((item) => item.roleName).join(", ") || null,
        // socialProfile section
        contactsocialfacebook: socialProfilesMap.get('Facebook') || '',
        contactsociallinkedin: socialProfilesMap.get('Linkedin') || '',
        contactsocialtwitter: socialProfilesMap.get('Twitter') || '',
        contactsocialwebsite: socialProfilesMap.get('Website') || '',
        contactsocialinstagram: socialProfilesMap.get('Instagram') || '',
        // phone section
        contactphonemobileCode :phonelistMapCode.get(PHONE_TYPE_IDS.MOBILE) || '',
        contactphonehomeCode :phonelistMapCode.get(PHONE_TYPE_IDS.HOME) || '',
        contactphonecp1Code :phonelistMapCode.get(PHONE_TYPE_IDS.CP1) || '',
        contactphonecp2Code :phonelistMapCode.get(PHONE_TYPE_IDS.CP2) || '',
        contactphoneworkCode :phonelistMapCode.get(PHONE_TYPE_IDS.WORK) || '',
        contactphonework :phonelistMap.get(PHONE_TYPE_IDS.WORK) || '',
        contactphonemobile :phonelistMap.get(PHONE_TYPE_IDS.MOBILE) || '',
        contactphonehome :phonelistMap.get(PHONE_TYPE_IDS.HOME) || '',
        contactphonecp1 :phonelistMap.get(PHONE_TYPE_IDS.CP1) || '',
        contactphonecp2 :phonelistMap.get(PHONE_TYPE_IDS.CP2) || '',
        // email section
        contactemailwork :emailMap.get('Work Email') || '',
        contactemailhome :emailMap.get('Home Email') || '',
        contactemailce1 :emailMap.get('CE1') || '',
        contactemailce2 :emailMap.get('CE2') || '',
      }
      this.appMainService.isHideSpinner('getFormattedContacts');
      return eachContact;
    }
  }
  changeSideHeaderPurchaseMenu() {
    this.changeSideHeader.emit(this.isShowSideBtn)
  }
  viewContact(contact: any): void {
    if (contact) {
      this.selectedContact = contact;
      this.contactModalHeader = 'View Contact';
      this.contactPopupOpenMode = 'view';
      this.displayContactAddEdit = true;
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'No contact selected for viewing'
      });
    }
  }

  editContact(contact: any): void {
    if (contact) {
      this.selectedContact = contact;
      this.contactModalHeader = 'Edit Contact';
      this.contactPopupOpenMode = 'edit';
      this.displayContactAddEdit = true;
    }
  }
  //#endregion Context Menu

  prepareContactforActiveInactive() {
    if (this.selectedContact.isPrimaryContact) {
      this.messageService.add({
        severity: "warn",
        summary: "Permission Denined",
        detail: "Not allowed to change status because this is primary contact for this Lead/Account/Vendor!",
      });
    }
    else {
      this.displayActiveInactiveModal = true;
      this.selectedIdForActiveInactive = this.selectedContact.id;
      this.statusId = this.selectedContact.statusId;
      this.activeInactiveFormType = 'Add';
    }

  }

  cancelActiveInactiveModal() {
    this.displayActiveInactiveModal = false;
    this.selectedIdForActiveInactive = null;
    this.statusId = null;
    this.activeInactiveFormType = '';
  }

  saveActiveInactiveModal() {
    this.displayActiveInactiveModal = false;
    this.isMenuShow = true
    this.selectedIdForActiveInactive = null;
    this.statusId = null;
    this.activeInactiveFormType = '';
    this.selectedContact = null;
    this.onStatusChanged();
  }

  loadContactList() {
    this.loadContacts(1, this.pageSize, true, this.sortFlag, this.sortCol);
  }

  //#region permission
  updatePermissionsAndMenu() {
    
    const userPermissions = this.permissionService.getPemrissionData();
    if (userPermissions.length) {
      let contactUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.CONTACT);

      contactUserPermission = contactUserPermission.permissions.sort((a, b) => (a.permissionId < b.permissionId) ? - 1 : 1);
      this.readPermission = contactUserPermission && (contactUserPermission[0].permissionId == 1 && contactUserPermission[0].statusId == 1) ? true : false;
      this.writePermission = contactUserPermission && (contactUserPermission[1].permissionId == 2 && contactUserPermission[1].statusId == 1) ? true : false;
      this.editPermission = contactUserPermission && (contactUserPermission[2].permissionId == 3 && contactUserPermission[2].statusId == 1) ? true : false;
      this.deletePermission = contactUserPermission && (contactUserPermission[3].permissionId == 4 && contactUserPermission[3].statusId == 1) ? true : false;
      this.exportPermission = contactUserPermission && (contactUserPermission[4].permissionId == 5 && contactUserPermission[4].statusId == 1) ? true : false;
    }

    this.configMenuItems = [];
    this.configMenuItemsCM = [];
    this.menuItems = [
      {
        label: 'New',
        icon: 'pi pi-plus',
        visible : this.writePermission,
        command: (event) => this.openContactForm()
      },
      {
        label: 'Settings',
        icon: 'pi pi-cog ',
        command: (event) => this.settings()
      }
    ];
    
    if (this.readPermission) {
      this.configMenuItems.push({
        label: 'View',
        icon: 'pi pi-list',
        command: async () => {
          this.viewContact({ id: this.selectedContact.id, contactAssociationTypeId: this.selectedContact.contactAssociationTypeId, mode: 'view' });
        }
      });
      this.configMenuItemsCM.push({
        label: 'View',
        icon: 'pi pi-list',
        command: async () => {
          this.viewContact({ id: this.selectedContact.id, contactAssociationTypeId: this.selectedContact.contactAssociationTypeId, mode: 'view' });
        }
      })
    }

    if (this.editPermission) {
      this.configMenuItems.push({
        label: 'Edit',
        icon: 'pi pi-pencil',
        command: async () => {
          this.editContact({ id: this.selectedContact.id, contactAssociationTypeId: this.selectedContact.contactAssociationTypeId, mode: 'edit' });
        }
      });
      this.configMenuItemsCM.push({
        label: 'Edit',
        icon: 'pi pi-pencil',
        command: async () => {
          this.editContact({ id: this.selectedContact.id, contactAssociationTypeId: this.selectedContact.contactAssociationTypeId, mode: 'edit' });
        }
      })
    }

    if (this.deletePermission) {
      this.configMenuItems.push({
        label: 'Delete',
        icon: 'pi pi-trash',
        command: async () => {
          this.deleteContact(this.selectedContact);
        }
      });
      this.configMenuItemsCM.push({
        label: 'Delete',
        icon: 'pi pi-trash',
        command: async () => {
          this.deleteContact(this.selectedContact);
        }
      })
    }
  }

  //#region delete API
  async deleteContact(contactDetails: any) {
    if (!contactDetails?.id || !contactDetails?.contactAssociationTypeId) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Invalid contact details'
      });
      return;
    }

    this.confirmationService.confirm({
      message: 'Do you want to delete this Contact?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: async () => {
        try {
          await this.sharedContactV1Service.deleteContact(
            contactDetails.id,
            contactDetails.contactAssociationTypeId
          );
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Contact deleted successfully'
          });

          // Reset state and reload data
          this.first = 0;
          this.isMenuShow = true ;
          this.selectedView = 'list' ;
          this.selectedContact = null;
          await this.loadContacts(1, this.pageSize);

        } catch (error) {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: error instanceof Error ? error.message : `${error?.error?.Message}`
          });
        }
      }
    });
  }

}
